
<template>
  <main>
    <my-header></my-header>
  <div class="body">
    <card
      v-for="dt in data"
      v-bind:key="dt.imp"
      :image="dt.cardimg"
      :heading="dt.cardHeading"
      :txt="dt.cardTxt"
      :imp="dt.imp"
    ></card>
    <float></float>
  </div>
  <my-footer></my-footer>
  </main>
</template>
<script>
import Float from "./components/floating.vue"
import Card from "./components/cards.vue";
import MyHeader from "./components/MyHeader.vue";
import MyFooter from "./components/MyFooter.vue"
export default {
  name: "App",
  components: {
    MyHeader,
    Card,
    Float,
    MyFooter

  },
  data() {
    return {
      data: [
        {
          cardimg: require("/src/assets/illustration-grow-together.svg"),
          cardHeading: "Grow Together",
          cardTxt:
            "Generate meaningful discussions with your audience and build a strong, loyal community. Think of the insightful converstions you miss out on wuth a feedback form",
          imp: "card-rv",
        },
        {
          cardimg: require("/src/assets/illustration-flowing-conversation.svg"),
          cardHeading: "Flowing Conversations",
          cardTxt:
            "You wouldn't paginate a conversation in real life, so why do it online? Our threads have just-in-time loading for a more natural flow.",
          imp: "card-dr",
        },
        {
          cardimg: require("/src/assets/illustration-your-users.svg"),
          cardHeading: "Your Users",
          cardTxt:
            "It takes no time at all to integrate Huddle with your app's authentication solution. This means, once signed in to your app, your users can start chatting immediately.",
          imp: "card-rv",
        },
      ],
    };
  },
};
</script>
<style scoped>
.body{
  padding-top: 4rem;
  padding-bottom: 10rem;
  position: relative;
}
</style>

